import { useAuth0 } from '@auth0/auth0-react'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

export function useFetchBearerToken(onTokenObtained: (token: string) => void) {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()

  // Using the `useQuery` hook to fetch the token will allow us to
  // to retry in case of an error.
  const { isError, data: token } = useQuery({
    queryKey: ['bearer-token'],
    enabled: isAuthenticated,
    queryFn: () => getAccessTokenSilently(),
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (token) {
      onTokenObtained(token)
    }
  }, [token, onTokenObtained])

  return {
    isErrorFetchingBearerToken: isError,
  }
}
